import { format, subDays } from "date-fns";
import { ru } from "date-fns/locale";

/**
 * Парсит дату из 1C-API формата `"2026-04-24 14:00:00"` как локальное время.
 * Заменяет пробел на `T` — без зоны JS трактует строку как локальную.
 */
export const parseApiDate = (input: string | null | undefined): Date | null => {
  if (!input) return null;
  const d = new Date(input.replace(" ", "T"));
  return Number.isNaN(d.getTime()) ? null : d;
};

/**
 * Format date as "DD.MM.YYYY"
 */
export const formatDateShort = (dateString: string | null): string => {
  try {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return format(date, "dd.MM.yyyy");
  } catch {
    return "";
  }
};

export const formatDate = (dateString: string) => {
  try {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return format(date, "d MMMM", { locale: ru });
  } catch {
    return "";
  }
};

export const formatDateWithYear = (input: string | Date) => {
  try {
    if (!input) return "";
    const date = input instanceof Date ? input : new Date(input);
    if (isNaN(date.getTime())) return "";
    return format(date, "d MMMM y", { locale: ru });
  } catch {
    return "";
  }
};

export const formatTime = (dateString: string) => {
  try {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return format(date, "HH:mm");
  } catch {
    return "";
  }
};

export const formatDateWithTime = (dateString: string) => {
  try {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return format(date, "d MMMM в HH:mm", { locale: ru });
  } catch {
    return "";
  }
};

export const formatDayOfWeek = (dateString: string) => {
  try {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return format(date, "EEEE", { locale: ru });
  } catch {
    return "";
  }
};

export const formatCancellationDeadline = (dateString: string) => {
  try {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const previousDay = subDays(date, 1);
    return format(previousDay, "d MMMM", { locale: ru });
  } catch {
    return "";
  }
};
